export default __webpack_public_path__ + "static/N0034-ada22b000f3b1821e8d03e02c0d1cd8f.png";